// import { Box } from '@mui/material'
// import React, { useEffect, useState } from 'react'
// import { fetchEmployeeLeave } from '../../../services/LeaveService'

// const LeaveCountLayout = () => {
//     const [leaveData, setLeaveData] = useState({ vacationLeave: 0, sickLeave: 0 })
//     useEffect(() => {
//         fetchEmployeeList()
//     }, [])

//     const fetchEmployeeList = async () => {
//         try {
//             let response = await fetchEmployeeLeave()

//             setLeaveData({
//                 vacationLeave: response.vacationLeave || 0,
//                 sickLeave: response.sickLeave || 0,
//                 emergencyLeave: response.emergencyLeave || 0
//             })
//         } catch (error) {
//             console.error('Error fetching fetchEmployeeList:', error)
//         } finally {
//         }
//     }
//     return (
//         <Box sx={{ height: '75%', width: '100%' }}>
//             <div className="flex items-center justify-between w-full mb-4">
//                 <h1 className="text-xl font-bold text-black">Leave</h1>
//             </div>

//             <div className="grid grid-cols-3 gap-4">
//                 {/* Vacation Leave */}
//                 <div className="p-4 bg-white rounded-lg shadow-md">
//                     <p className="text-2xl font-bold text-blue-600">{leaveData.vacationLeave}</p>
//                     <h3 className="text-sm font-small text-blue-800">Vacation Leave</h3>
//                 </div>
//                 {/* Sick Leave */}
//                 <div className="p-4 bg-white rounded-lg shadow-md">
//                     <p className="text-2xl font-bold text-red-600">{leaveData.sickLeave}</p>
//                     <h3 className="text-sm font-small text-red-800">Sick Leave</h3>
//                 </div>
//                 {/* Sick Leave */}
//                 <div className="p-4 bg-white rounded-lg shadow-md">
//                     <p className="text-2xl font-bold text-purple-600">{leaveData.emergencyLeave}</p>
//                     <h3 className="text-sm font-small text-purple-800">Emergency Leave</h3>
//                 </div>
//             </div>
//         </Box>
//     )
// }

// export default LeaveCountLayout

import { Box, Card, CardContent, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { fetchEmployeeLeave } from '../../../services/LeaveService'
import { HiOutlineBriefcase, HiOutlineHeart, HiOutlineLightningBolt } from 'react-icons/hi'

const LeaveCountLayout = () => {
    const [leaveData, setLeaveData] = useState({
        vacationLeave: 0,
        sickLeave: 0,
        emergencyLeave: 0
    })

    useEffect(() => {
        fetchEmployeeList()
    }, [])

    const fetchEmployeeList = async () => {
        try {
            const response = await fetchEmployeeLeave()
            setLeaveData({
                vacationLeave: response.vacationLeave || 0,
                sickLeave: response.sickLeave || 0,
                emergencyLeave: response.emergencyLeave || 0
            })
        } catch (error) {
            console.error('Error fetching employee leave data:', error)
        }
    }

    const leaveCards = [
        {
            label: 'Vacation Leave',
            value: leaveData.vacationLeave,
            borderColor: '#64748b',
            valueClass: 'text-slate-700',
            labelClass: 'text-slate-500',
            icon: <HiOutlineBriefcase className="text-slate-500 text-3xl" />
        },
        {
            label: 'Sick Leave',
            value: leaveData.sickLeave,
            borderColor: '#d11919',
            valueClass: 'text-red-600',
            labelClass: 'text-red-700',
            icon: <HiOutlineHeart className="text-red-500 text-3xl" />
        },
        {
            label: 'Emergency Leave',
            value: leaveData.emergencyLeave,
            borderColor: '#b45309',
            valueClass: 'text-amber-700',
            labelClass: 'text-amber-800',
            icon: <HiOutlineLightningBolt className="text-amber-500 text-3xl" />
        }
    ]
    return (
        <Box sx={{ height: '100%', width: '100%' }}>
            <div className="flex items-center justify-between w-full mb-6">
                <h1 className="page-title">Your Leave Balance</h1>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {leaveCards.map((card, index) => (
                    <Card
                        key={index}
                        className="transition-shadow hover:shadow-md"
                        sx={{ borderLeft: `6px solid ${card.borderColor}` }}
                    >
                        <CardContent className="flex items-center gap-4">
                            <div>{card.icon}</div>
                            <div>
                                <Typography variant="h5" className={`${card.valueClass} font-bold`}>
                                    {card.value}
                                </Typography>
                                <Typography variant="subtitle2" className={card.labelClass}>
                                    {card.label}
                                </Typography>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </Box>
    )
}

export default LeaveCountLayout
